// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format3 } from '../../constants';

/** France */
const FR: PhoneNumberData = [33, 'FR', 9, format3];

export default FR;
